<script lang="ts" setup>
const props = defineProps({
  color: {
    type: String,
    default: "primary",
  },
  tooltip: {
    type: String,
    required: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showSpinner: {
    type: Boolean,
    default: false,
  },
  size: {
    type: Number,
    default: 30,
  },
  active: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <span
    class="relative flex flex-col align-center items-center p-2 justify-center rounded hover:bg-medium-default hover:bg-opacity-10 transition-all duration-150 cursor-pointer select-none"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
    }"
    :class="{
      'text-secondary-default': props.color == 'secondary' && active != true,
      ' bg-secondary/10 hover:bg-secondary/5':
        props.color == 'secondary' && active == true,

      'text-google-default': props.color == 'google' && active != true,
      'text-google-on bg-google/10 hover:bg-google/5':
        props.color == 'google' && active == true,

      'text-danger-default': props.color == 'danger' && active != true,
      'text-danger-on bg-danger/10 hover:bg-danger/5':
        props.color == 'danger' && active == true,

      'text-primary-default': props.color == 'primary' && active != true,
      'text-primary/80  bg-primary/10 hover:bg-primary/5':
        props.color == 'primary' && active == true,

      'text-link': props.color == 'default' && active != true,
      'text-link-on bg-link/10 hover:bg-link/5':
        props.color == 'default' && active == true,
      '!text-medium-tint !active:bg-opacity-10': disabled,
      ' !active:bg-opacity-20': disabled != true,
    }"
    v-tooltip="tooltip"
  >
    <slot />
    <div
      v-if="showSpinner"
      class="absolute top-0 left-0 w-full h-full bg-medium-default rounded flex items-center justify-center text-primary-default bg-opacity-20"
    >
      <icon name="svg-spinners:ring-resize" />
    </div>
  </span>
</template>

<style scoped></style>
